import { Row, Col, Card, CardBody } from 'reactstrap';
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import Chart from 'chart.js';
import { parseOptions, chartOptions } from 'variables/charts';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import DashboardEnergyConsumedChart from '../Analytics/DashboardEnergyConsumedChart';
import DashboardChargingSessionsAnalytics from '../Analytics/DashboardChargingSessionsAnalytics';
import DashboardCorporateLevelAnalytics from '../Analytics/DashboardCorporateLevelAnalytics';
parseOptions(Chart, chartOptions());
Chart.plugins.register(ChartDataLabels);

// Chart.plugins.register(ChartDataLabels);
const CorporateAdminDashboardAnalytics = ({
  chargerId,
  notifyYearChange,
  setClickedMonthIndex,
}) => {
  const minYear = 2022;
  const [maxYear, setMaxYear] = useState(0);
  const [selectedYear, setSelectedYear] = useState(null);

  const yearChangeHandler = (action) => {
    let newYear = selectedYear;
    if (action === 'next' && selectedYear < maxYear) newYear += 1;
    else if (action === 'prev' && selectedYear > minYear) newYear -= 1;
    if (newYear !== selectedYear) {
      setSelectedYear(newYear);
    }
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setMaxYear(currentYear);
    setSelectedYear(currentYear);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ margin: 20 }}>
      <Card style={{ width: '100%', height: '100%' }}>
        <CardBody>
          <Row>
            <Col
              className="text-left"
              style={{
                fontWeight: 600,
                margin: '10px 0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <LeftCircleOutlined
                onClick={() => yearChangeHandler('prev')}
                style={{
                  marginRight: '10px',
                  color: selectedYear > minYear ? '#2675b8' : 'grey',
                }}
              />
              <span style={{ fontSize: '18px' }}>Year {selectedYear}</span>
              <RightCircleOutlined
                onClick={() => yearChangeHandler('next')}
                style={{
                  marginLeft: '10px',
                  color: selectedYear < maxYear ? '#2675b8' : 'grey',
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="12" md="12" lg="12">
              <DashboardEnergyConsumedChart
                granularity={'monthly'}
                selectedYear={selectedYear}
                handleBarClick={() => {}}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 30 }}>
            <Col sm="12" md="12" lg="12">
              <DashboardChargingSessionsAnalytics
                granularity={'monthly'}
                selectedYear={selectedYear}
                handleBarClick={() => {}}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 30 }}>
            <Col sm="12" md="12" lg="12">
              <DashboardCorporateLevelAnalytics selectedYear={selectedYear} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default CorporateAdminDashboardAnalytics;
